import React, { FC, useState } from 'react';

import { Desktop, Label, Mobile, useMobile } from 'Modules/ui2';

import { PriceCardKeys, Tariffs, MobileTariffs, Tariff } from './Tariffs';
import { Documents } from '../Documents';
import { ContinueButton, RegisterButton, ShowErrorButton } from './Buttons';
import { RateProps } from './types';
import styles from './index.module.scss';


const tariffs: Record<PriceCardKeys, Tariff> = {
    application: {
        proffits: [0],
        button: RegisterButton,
    },
    factoring: {
        className: styles.factoringPrice,
        selectedClassName: styles.selected,
        proffits: [0, 1, 2, 3],
        button: ContinueButton,
    },
    majors: {
        className: styles.majorsPrice,
        proffits: [0, 1, 2, 3, 4],
        priceTextSize: '21-24',
        button: ContinueButton,
    },
};

const mobileTariffs: Record<PriceCardKeys, Tariff> = {
    application: {
        proffits: [0],
        onlySelected: true,
        button: RegisterButton,
    },
    factoring: {
        className: styles.factoringPrice,
        selectedClassName: styles.selected,
        proffits: [0, 1, 2, 3],
        button: props => <ShowErrorButton type='factoringAndDiscounting' {...props} />,
    },
    majors: {
        className: styles.majorsPrice,
        proffits: [4],
        onlySelected: true,
        priceTextSize: '21-24',
        button: props => <ShowErrorButton type='onRequest' {...props} />,
    },
};

export const Rate: FC<RateProps> = props => {
    const { landingOwnerUid, t } = props;
    const [selected, setSelected] = useState<PriceCardKeys>('application');

    const Button = landingOwnerUid ? ContinueButton : tariffs[selected].button;

    const mobile = useMobile();

    return (
        <div>
            <Mobile>
                <div className={styles.header}>
                    <Label textSize='24' component='div'>
                        {t('rate.step2')}
                    </Label>
                    <Label weight='demibold' textSize='24' component='div'>
                        {t('rate.header')}
                    </Label>
                </div>
                <MobileTariffs
                    data={mobileTariffs}
                    selected={selected}
                    select={setSelected}
                    buttonProps={props}
                />
            </Mobile>
            <Desktop>
                <Label className={styles.header} weight='demibold' textSize='32' component='div'>
                    {t('rate.header')}
                </Label>
                <Tariffs
                    data={tariffs}
                    selected={selected}
                    select={setSelected}
                    buttonProps={props}
                />
                <Button
                    className={styles.button}
                    t={t}
                    {...props}
                />
            </Desktop>
            <Documents className={styles.documents} isDefaultOpen={!mobile} />
        </div>
    );
};
